import React from "react";
import { Package } from "lucide-react";

import { BACKEND_BASE } from "@/lib/api";

const resolve = (src) => (src && src.startsWith("/") ? `${BACKEND_BASE}${src}` : src);

// Lazy, async-decoded image with fade-in, fallback source and one delayed retry.
export default function ProductImg({ src, fallback, alt, className, eager = false, testId, brand }) {
  const [stage, setStage] = React.useState(0);
  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => {
    setStage(0);
    setLoaded(false);
  }, [src]);

  const sources = [resolve(src), resolve(fallback) || resolve(src)];
  const current = stage === 2 ? `${sources[1]}${sources[1]?.includes("?") ? "&" : "?"}r=1` : sources[Math.min(stage, 1)];

  const onError = () => {
    if (stage === 0) setStage(1);
    else if (stage === 1) setTimeout(() => setStage(2), 1500);
    else setStage(3);
  };

  if (!src || stage === 3) {
    if (brand !== undefined) {
      return (
        <div className={`relative flex flex-col items-center justify-center gap-2 bg-[#F6F5F1] ${className}`} data-testid={testId ? `${testId}-branded` : undefined}>
          <span className="font-heading text-base sm:text-lg font-extrabold uppercase tracking-[0.12em] text-slate-800 text-center px-3 leading-tight line-clamp-2">{brand || "Zealous Ventures"}</span>
          <span className="h-0.5 w-8 bg-[#FFDA00] rounded-full" />
          <img src="/logo.png" alt="" aria-hidden="true" className="absolute bottom-3 h-5 w-auto opacity-40 grayscale" />
        </div>
      );
    }
    return (
      <div className={`flex items-center justify-center bg-gradient-to-br from-slate-100 to-slate-200 ${className}`} data-testid={testId ? `${testId}-placeholder` : undefined}>
        <Package className="h-10 w-10 text-slate-300" />
      </div>
    );
  }
  return (
    <img
      src={current}
      alt={alt}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      fetchpriority={eager ? "high" : "auto"}
      className={`${className} transition-opacity duration-300 ${loaded ? "opacity-100" : "opacity-0"}`}
      onLoad={(e) => (e.currentTarget.naturalWidth <= 1 ? setStage(3) : setLoaded(true))}
      onError={onError}
      data-testid={testId}
    />
  );
}
